import * as React from 'react';
import { useState } from 'react';
import Button from '../../../lib/bootstrap-ui/Button';
import Modal, {
    ModalBody,
    ModalFooter,
    ModalHeader
} from '../../../lib/bootstrap-ui/Modal';
import { Booking } from '../../../models/bookings/Booking';
import PhoneNumberInput from '../../common/PhoneNumberInput';

interface EditContactNumberModalProps {
    booking: Booking;
    showModal: boolean;
    onSave(contactNumber: string | null): void;
    onClose(): void;
}

const EditContactNumberModal: React.FC<EditContactNumberModalProps> = ({
    booking,
    showModal,
    onSave,
    onClose
}) => {
    const [bookingContactNumber, setBookingContactNumber] = useState(
        booking.contactNumber
    );
    const [contactNumberIsValid, setContactNumberIsValid] = useState(false);

    const handleSave = () => {
        onSave(bookingContactNumber);
        setBookingContactNumber(null);
    };

    const disableSave =
        !contactNumberIsValid || booking.contactNumber === bookingContactNumber;

    return (
        <Modal isOpen={showModal} onRequestClose={onClose}>
            <ModalHeader>
                <h5>Edit Contact Number: {booking.reference}</h5>
            </ModalHeader>
            <ModalBody>
                <PhoneNumberInput
                    label={'Contact Number:'}
                    placeholder={'Contact Number...'}
                    onPhoneNumberChanged={setBookingContactNumber}
                    phoneNumber={bookingContactNumber}
                    required
                    onPhoneNumberValidation={setContactNumberIsValid}
                />
            </ModalBody>
            <ModalFooter>
                <Button styleType="secondary" onClick={onClose}>
                    Close
                </Button>
                <Button
                    styleType="primary"
                    disabled={disableSave}
                    onClick={handleSave}
                >
                    Save
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default EditContactNumberModal;
